export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - 串流直播 NBA 賽事 | NBA.com',
	seo_meta_desc_leaguepass: 'League Pass 用戶可串流直播及點播重溫 NBA 賽事。點擊這裡前往您的帳戶。',
	seo_meta_keywords_leaguepass: 'NBA視訊，NBA集錦，籃球影片，最佳球賽，扣籃，特輯',
	seo_meta_title_featured: '串流直播 NBA 賽事和觀看賽事精華 | NBA.com',
	seo_meta_desc_featured: '免費收看 NBA 賽事精華、新聞和分析。此外，瞭解更多 NBA TV 及 League Pass 的訂閱計劃，並在您喜愛的裝置上觀賞直播賽事。',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - 串流直播賽事和全天候報導 NBA消息 | NBA.com',
	seo_meta_desc_nbatv: '串流 NBA TV 直播賽事或觀賞極具代表性的經典賽事。另外，您也可收看聯盟的報導節目和分析。',
	seo_meta_keywords_nbatv: 'NBA TV，節拍，經典球衣，NBA直播，真實NBA，NBA比賽時間，內幕花絮，演播室節目，跳躍',
	seo_meta_title_classicgames: 'NBA TV 用戶可串流經典賽事及更多 | NBA.com',
	seo_meta_desc_classicgames: 'NBA TV 用戶可觀賞極具代表性的 NBA 對賽。此外，您也可以串流 NBA TV 直播賽事和收看聯盟的報導節目和分析。',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: '點擊這裡串流相關內容 | NBA.com',
	seo_meta_title_videolist: '點擊這裡 {0} 串流賽事 | NBA.com',
	seo_meta_desc_videolist: '點擊這裡 {0} 觀看影片。此外，瞭解更多 NBA TV 及 League Pass 的訂閱計劃，並在您喜愛的裝置上觀賞直播賽事。',
	seo_meta_title_videolist_show: 'NBA TV 用戶 {0} 串流賽事 | NBA.com',
	seo_meta_desc_videolist_show: '點擊這裡 {0} 觀看賽事。此外，您也可串流 NBA TV 直播賽事、觀賞極具代表性的經典賽事及分析。',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: '點擊這裡 {0} 串流賽事 | NBA.com',
	seo_meta_desc_videolist_feed: '點擊這裡 {0} 觀看影片。此外，瞭解更多 NBA TV 及 League Pass 的訂閱計劃，並在您喜愛的裝置上觀賞直播賽事。',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA TV 用戶可串流直播室節目及更多 | NBA.com',
	seo_meta_desc_shows: '瞭解更多及串流最新的 NBA TV 節目和點播重溫所有集數。此外，串流直播 NBA TV 直播賽事、經典賽事和分析。',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: '首頁 | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: '所有頻道 | NBA',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: '頻道 | NBA',
	seo_meta_pre_title_categories: '所有類別 | NBA.com',
	seo_meta_title_categories: '所有類別 | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: '類別 | NBA.com',
	seo_meta_title_category: '類別 | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: '點擊這裡觀看影片 | NBA.com',
	seo_meta_pre_title_event: '點擊這裡觀看活動 | NBA.com',
	seo_meta_title_events: '活動 | NBA',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: '點擊這裡 {0} 串流 | NBA.com',
	seo_meta_desc_event: '點擊這裡 {0} 觀看。此外，瞭解更多 NBA TV 及 League Pass 的訂閱計劃，並在您喜愛的裝置上觀賞直播賽事。',
	seo_meta_keywords_event: '',
	seo_meta_title_search: '搜尋 | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: '網頁不存在 | NBA',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: '點擊這裡 {0} 串流賽事 | NBA.com',
	seo_meta_title_game: '點擊這裡 {0} 串流 | NBA.com',
	seo_meta_desc_game: '點擊這裡 {0} 觀看。此外，瞭解更多 NBA TV 及 League Pass 的訂閱計劃，並在您喜愛的裝置上觀賞直播賽事。',
	seo_meta_keywords_game: '',
	seo_meta_title_video: '點擊這裡 {0} 串流 | NBA.com',
	seo_meta_desc_video: '點擊這裡 {0} 觀看。此外，瞭解更多 NBA TV 及 League Pass 的訂閱計劃，並在您喜愛的裝置上觀賞直播賽事。',
	seo_meta_keywords_video: 'NBA視訊，NBA集錦，籃球影片，最佳球賽，扣籃，特輯',
	seo_meta_title_episode: 'NBA TV 用戶可 {0} 串流 | NBA.com',
	seo_meta_desc_episode: '點擊這裡 {0} 觀看賽事。此外，您也可串流 NBA TV 直播賽事、觀賞極具代表性的經典賽事及分析。',
	seo_meta_keywords_episode: 'NBA視訊，NBA集錦，籃球影片，最佳球賽，扣籃，特輯',
	seo_meta_title_channel: 'NBA TV 現場直播賽事 | NBA.com',
	seo_meta_desc_channel: 'NBA TV直播每週為您提供全天24小時的NBA比賽直播和存檔影片、演播室節目及分析師報導的NBA TV頻道串流服務',
	seo_meta_keywords_channel: 'NBA TV，節拍，經典球衣，NBA直播，真實NBA，NBA比賽時間，內幕花絮，演播室節目，跳躍',
	seo_meta_title_tvguide: 'NBA TV 串流直播時間表 | NBA.com',
	seo_meta_desc_tvguide: 'NBA TV 用戶可查看甚麼時候能夠在您喜愛的裝置上串流 NBA TV 直播賽事和直播室節目。此外，您也可以點播重溫直播室節目及分析。',
	seo_meta_keywords_tvguide: 'NBA TV，節拍，經典球衣，NBA直播，真實NBA，NBA比賽時間，內幕花絮，演播室節目，跳躍',

	// Common
	timezone: '東部時間',
	default_feed_error_message: '出現錯誤，現無法提供此內容。請於稍後再試。',
	watch_in_app: '在 NBA 應用程式上觀賞球賽',
	ad_blocked_message: '檢測到您已安裝廣告攔截程式：NBA.com 的內容含有廣告。如欲繼續觀賞我們的內容，請關閉您的廣告攔截程式。',

	// Item
	no_content: '目前沒有內容可觀看',
	see_more: '查看更多',
	now_playing: '現正播放',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'LEAGUE PASS',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: '您最喜歡的視訊數量已達上限。請在添加更多視訊前先移除一部分。',
	item_live: '現場直播',
	add_favourite_title: '加入至我的喜愛',
	remove_favourite_title: '從我的喜愛中移除',
	// Channel: Schedule
	p_channel_live: '現場直播',
	p_channel_schedule_title: 'NBA TV 時間表',
	p_channel_schedule_watch: '收看',
	p_channel_live24x7_title: 'NBA TV 每日 24 小時全天候無間直播',
	p_channel_live24x7_see_full_schedule: '查看完整的時間表',
	p_channel_live24x7_up_next: '下一頁',
	p_channel_live24x7_on_demand: 'NBA TV：點播重溫',
	p_channel_live24x7_collection: '我的收藏',
	p_channel_live24x7_demand_1_logo_text: '原創節目',
	p_channel_live24x7_demand_1_show_name: 'NBA TV 節目',
	p_channel_live24x7_demand_1_show_desc: '原創 NBA TV 節目包括「Shaqtin\' a Fool」、「Beyond the Paint」、「Game Time」以及「Basketball Stories」',
	p_channel_live24x7_demand_2_logo_text: '經典賽事',
	p_channel_live24x7_demand_2_show_name: 'NBA 經典賽事',
	p_channel_live24x7_demand_2_show_desc: '觀賞整場經典賽事，包括自 2000 年以來的所有總決賽對碰、聯盟歷史時刻及傳奇球員特輯',

	// Channel: Clips
	p_channel_error_msg: '暫不適用',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: '賽程表',

	// NBA TV Shows:
	p_nba_tv_shows: 'NBA TV 節目',
	p_nba_tv_no_access_title: '24/7 NBA：緊貼賽事分析、直播室評述員分析、原創節目及更多精彩內容！',
	p_nba_tv_no_access_desc: '觀賞直播賽事，以及點播重溫經典賽事和其他節目。',
	p_nba_tv_no_access_note: '播出或會受到限制',

	// tv show item
	tv_show_item_latest_episode: '最新一集',
	tv_show_item_no_latest_episode: '沒有最新一集',
	see_all: '查看全部',
	// header
	header_menu_watch: '收看',
	header_menu_featured: '精選',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: '球員',
	videos: '影片',
	teams: '球隊',
	most_searched: '最多人搜尋',
	no_result: '沒有數據',
	search_filter_type_most_relevant: '最相關',
	search_filter_type_most_viewed: '最多人觀看',
	search_filter_type_most_recent: '最近期',
	search_filter_type_last_30_days: '最近 30 天',
	search_filter_type_last_6_months: '最近 6 個月',
	search_result_label: '“{keyword}” 的搜尋結果',
	search_result_info: '查看 {keyword} 的所有搜尋結果',
	search_placeholder: '搜尋影片庫',
	load_more: '下載更多',

	// button
	button_subscribe: '訂閱',
	button_sign_in: '登入',
	button_tv_provider: '選擇電視節目供應商',

	// league page
	p_league_pass_no_access_title: '在您的電腦、智能手機及電視等任何裝置上觀賞直播賽事或點播重溫賽事！',
	p_league_pass_no_access_desc: 'NBA League Pass 帶您現場直擊精彩動態：您可選擇觀看整個聯盟的所有賽事、只觀看你喜愛球隊的賽事或收看單場賽事，立即查看更多賽事選項。',
	p_league_pass_no_access_note: '受條款限制',

	// Video
	category_title: '視訊',
	p_video_playlist_title: '播放列表',
	p_video_episode_text: '集數',
	p_no_access_league_pass_title: '啟動 NBA League Pass 並開始觀看：',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: 'NBA League Pass 帶您現場直擊精彩動態：您可選擇觀看整個聯盟的所有賽事、只觀看你喜愛球隊的賽事或收看單場賽事，立即查看更多賽事選項。',
	p_no_access_league_pass_terms: '受條款限制',
	p_no_access_league_pass_geo_desc: '根據您目前的所在地區，您無法透過 NBA League Pass 和 NBA TV 觀看這場賽事。NBA League Pass 用戶可於賽事播放後三天重溫這場已存檔的賽事。請諮詢您當地電視台和電台廣播商的時間表，以瞭解您所在地區的廣播詳情。',
	p_no_access_league_pass_not_found_desc: '很抱歉，找不到您查詢的影片。',
	p_no_access_event_geo_desc: '此轉播無法提供給美國或加拿大地區的球迷觀看。請於美國的 ESPN 和加拿大的 TSN 或 Sportsnet 收看賽事。',
	p_no_access_event_not_found_desc: '很抱歉，找不到您查詢的活動。',
	p_no_access_nba_tv_title: '啟動 NBA League Pass 並開始觀看：',
	p_no_access_nba_tv_desc: '觀賞直播賽事及點播重溫經典賽事及其他節目。',
	p_no_access_nba_tv_terms: '受條款限制',
	p_no_access_nba_tv_geo_desc: '根據您目前的所在地區，您無法透過 NBA League Pass 和 NBA TV 觀看這場賽事。NBA League Pass 用戶可於賽事播放後 3 天重溫這場已存檔的賽事。請諮詢您當地電視台和電台廣播商的時間表，以瞭解您所在地區的廣播詳情。',
	p_no_access_nba_tv_not_found_desc: '很抱歉，找不到您查詢的頻道。',
	p_no_access_up_next: '下一頁',
	p_video_completed_title: '播放列表完成',
	p_video_completed_desc: '返回並瀏覽或查看您的下一個播放列表',
	p_video_share_to: '分享給：',
	p_video_more_to_watch: '更多精彩內容：',

	// Event
	p_event_section_title: '節目',
	p_event_playlist_title: '播放列表',
	p_event_button_watch: '收看',
	p_event_button_listen: '收聽',
	p_event_button_ticket: '門票',

	// notfound page
	notfound: '抱歉，找不到您查詢的頁面。',
	notfound_desc: '請檢查 URL 是否有誤。 <br/> 您亦可以嘗試使用網站導覽或搜尋工具來尋找您想觀看的內容。',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: '您的 NBA League Pass 帳戶已達到串流上限。請點擊「繼續」在本裝置繼續收看。',
	modal_pcm_custom: '繼續',
	modal_pcm_close: '取消',
	modal_pcm_ok: '確認',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: '這部影片無法在您的裝置上播放。點擊 <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'> 這裡 </a> 獲得更多協助。',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: '確認',
	modal_video_unsupported_ok: '確認',

	// FreeSample
	freesample_notice_time: '剩餘時間',
	freesample_notice_title: '享受你的 {0} 分鐘權限',
	freesample_notice_desc: '訂閱完整的 League Pass 套餐，在 {0} 分鐘結束後繼續存取內容。',
	freesample_notice_subscribe_button: '訂閱',
	freesample_notice_cancel_button: '隨時取消',
	freesample_popup_title: '你的權限已結束',
	freesample_popup_subtitle: '訂閱 League Pass，觀看更多 NBA 精彩內容。',
	freesample_popup_link: '瞭解更多',
	freesample_popup_get_minutes_button: '取得 {0} 分鐘',

	// Video list
	reg_required_desc: '您必須先登入才能查看此內容',
	favorite_teams_title: '最喜愛球隊',
	bookmarked_title: '已儲存',
	watch_history_title: '繼續觀看',
	game_schedule_title: '比賽日程表',
	recommended_title: '推薦',
	season_text: '賽季',

	// profile page
	section_information_title: '我的個人資料',
	section_information_desc: '更新您的個人資料',
	section_information_email: '電郵',
	section_information_email_update: '更新電郵地址',
	section_information_password: '密碼',
	section_information_password_update: '更改密碼',
	section_information_social: '社交聯絡',
	section_information_nosocial_message: '您沒有已連結的任何帳戶。',
	section_information_firstname: '名字',
	section_information_lastname: '姓氏',
	section_information_birth: '出生日期',
	section_information_country: '國家/地區',
	section_information_postalcode: '郵政區號',
	section_information_edit: '編輯',
	section_tv_provider_title: '我的電視節目供應商',
	section_tv_provider_desc: '透過您的電視節目供應商觀看直播賽事及串流。',
	section_tv_provider_faq: '電視節目供應商常見問題',
	section_tv_provider_sign_out: '登出',
	section_tv_provider_sign_in: '以電視節目供應商帳戶登入',
	section_fantasy_title: '梦幻',
	section_fantasy_desc: '查看你的 Fantasy 帳戶資料',
	section_fantasy_displayname: '顯示名稱',
	section_marketing_title: '電郵偏好設定',
	section_marketing_desc: '查看您的市場推廣信息和用戶私隱偏好設定',
	section_marketing_newsletters: '電子通訊',
	section_marketing_message: 'NBA 訊息和廣告',
	section_marketing_newsletters_desc_1: '每天透過電郵送上 NBA 的最新消息',
	section_marketing_newsletters_desc_2: 'NBA 官方小聯盟 NBA G League 的最新消息及焦點',
	section_marketing_newsletters_desc_3: 'NBA 少年籃球運動 Jr. NBA  的最新消息及資訊',
	section_marketing_newsletters_desc_4: 'NBA 應用程式的最新功能，以及NBA League Pass 的最新消息及優惠',
	section_marketing_newsletters_desc_5: 'NBA 門票優惠、合作伙伴優惠、活動及商品折扣',
	section_marketing_newsletters_desc_6: '每週透過電郵送上精選 NBA 新聞及內容',
	section_marketing_newsletters_desc_7: 'WNBA 的最新消息、優惠及其合作夥伴提供的優惠',
	section_marketing_personal_title: '我的個人資料',
	section_marketing_personal_desc: '請使用我的個人資料以便 NBA 向我發送訊息，以及收取 NBA 和其合作夥伴所推出產品和計劃的廣告。',
	section_marketing_update_button: '更新市場推廣訊息偏好選項。',
	section_marketing_update_success: '您已成功更新偏好設定。',
	section_ccpa_title: '不要出售我的個人資料',

	// profile edit modal
	email_modal_title: '更新電郵地址',
	email_modal_new_email_label: '新電郵地址',
	email_modal_update: '更新',
	email_modal_cancel: '取消',
	password_modal_title: '更改密碼',
	password_modal_current_label: '目前密碼',
	password_modal_new_label: '新密碼',
	password_modal_confirm_label: '確認密碼',
	password_modal_update: '更新',
	password_modal_cancel: '取消',
	personal_modal_title: '更新個人資料',
	personal_modal_email: '電郵',
	personal_modal_password: '密碼',
	personal_modal_birth: '出生日期',
	personal_modal_social: '社交聯絡',
	personal_modal_firstname: '名字',
	personal_modal_lastname: '姓氏',
	personal_modal_country: '國家 / 地區',
	personal_modal_postalcode: '郵政編碼',
	personal_modal_zipcode: '郵政編碼',
	personal_modal_postalcode_invalid_message: '必須為有效的郵政編碼',
	personal_modal_zipcode_invalid_message: '必須為有效的郵政編碼',
	personal_modal_update: '更新',
	personal_modal_cancel: '取消',

	// payflow
	payflow_profile_name: '名字',
	payflow_profile_email: '電郵',

	// account page
	header_menu_account_my_account: '我的帳戶',
	header_menu_account_manage_account: '管理帳戶',
	header_menu_account_favorite_teams: '最喜歡的球隊',
	header_menu_account_favorite_players: '最喜歡的球員',
	header_menu_account_viewing_history: '收看記錄',
};
